import { useEffect, useLayoutEffect } from 'react';

// useLayoutEffect has a spammy warning in SSR about it having no effect there,
// which is dumb because neither useEffect nor useLayoutEffect is supposed
// to do anything in SSR. So to make the warning shut up, we just use
// useEffect in SSR while keep useLayoutEffect in browser; the end result
// should make zero difference because as mentioned, both are noop in SSR
// only downside is no linting for deps, so only use this after you verified
// your deps
export const useLayoutEffectWithoutSSRComplaining =
  typeof window === 'undefined' || process.env.NODE_ENV === 'test'
    ? useEffect
    : useLayoutEffect;
